export enum ScheduleType {    
    none = 0,
    runOnce = 1,
    runEvery = 2,
    CRON = 3,
}
